<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<footer class="d-flex align-items-center justify-content-center gap px-2">
  <div class="zero-text p-small-reg">
    ©
    <a class="zero-text link" [href]="externalLinks.website" target="_blank" rel="noopener noreferrer">finanzen.net zero GmbH</a>
    {{ currentYear }}
  </div>
  <a class="d-none d-sm-block zero-text link p-small-reg" [href]="externalLinks.impressum" target="_blank" rel="noopener noreferrer">
    {{ 'footer.legal.imprint' | transloco }}
  </a>
  <a class="d-none d-sm-block zero-text link p-small-reg" [href]="externalLinks.datenschutz" target="_blank" rel="noopener noreferrer">
    {{ 'footer.legal.privacy' | transloco }}
  </a>
  <a class="d-none d-sm-block zero-text link p-small-reg" [href]="externalLinks.disclaimer" target="_blank" rel="noopener noreferrer">
    {{ 'footer.legal.disclaimer' | transloco }}
  </a>
  <a class="d-none d-sm-block zero-text link p-small-reg" (click)="sourcePoint.displayPrivacyManagerModal()">
    {{ 'footer.legal.privacy-settings' | transloco }}
  </a>
  @if (!hideLogout()) {
    <a class="d-block zero-text link p-small-reg" (click)="authService.explicitLogout()">{{ 'footer.logout' | transloco }}</a>
  }
</footer>
